import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IFooterImages } from "InterfacesTypes/interfaces";

export interface IFooterImagesState {
  footerSectionImages: IFooterImages[];
  loading: boolean;
  error: string | null;
}

const initialState: IFooterImagesState = {
  footerSectionImages: [],
  loading: false,
  error: null,
};

export const fetchFooterSectionImages = createAction("footerSectionImages/fetchFooterSectionImages");

export const footerSectionImagesSlice = createSlice({
  name: "footerSectionImages",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IFooterImages[]>) {
      state.loading = false;
      state.footerSectionImages = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setFooterSectionImages(state, action: PayloadAction<IFooterImages[]>) {
      state.footerSectionImages = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setFooterSectionImages } =
  footerSectionImagesSlice.actions;

export const footerSectionImagesReducer = footerSectionImagesSlice.reducer;